// extracted by mini-css-extract-plugin
export default {"title":"wJMgxtuqeJ","button":"vh8xNluRM5"};
    if(module.hot) {
      // 1633091673176
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  